import React ,{useEffect, useState} from 'react';
import * as actions from "../actions";
import {connect} from 'react-redux';
// eslint-disable-next-line no-unused-vars
import * as _ from 'lodash';
import Select from 'react-select';
import {
    Button,
    Col,
    Container,
    Icon,
    ProgressBar,
    Row,
    Table,
    TextInput,
} from "react-materialize";
import PageHeader from './TopHeader/PageHeader';
import {
	DIGITALOCEAN_PUBLIC_URL,
	buildTimestampedUploadFileName,
	listDigitalOceanSpacesObjects,
	uploadToDigitalOceanSpaces,
} from "../api/Util";

export default connect(mapStateToProps, actions)((props) => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [viewAs, setViewAs] = useState("");
    const [link, setLink] = useState([]);
    const [videoList, setVideoList] = useState("");
    const [progressBar, setProgressBar] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [toolTipText, setToolTipText] = useState("Copy to Clipboard");

    useEffect(() => {
        if(props.users == null && !props.users.loadingUsers) {
            props.fetchAllUsers();
        }
        if (!props?.users?.customers && !props.users.loadingCustomers) {
            props.fetchAllCustomers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFileInput = (e) => {
        setSelectedFile(e.target.files);
    }

    let progressInfos = [];

    const handleClick = (selectedFile) => {
        for (let i = 0; i < selectedFile.length; i++) {
            progressInfos.push({ percentage: 0, fileName: selectedFile[i].name });
            uploadFile(i, selectedFile[i]);
        }
    };

    const uploadFile = (i, file) => {

        setIsLoading(true);
        const uploadFileName = buildTimestampedUploadFileName(file);
		const key = `${viewAs.value}/${uploadFileName}`;
        uploadToDigitalOceanSpaces({
			file,
			key,
			onComplete: (err, data) => {
            if (err) {
                setIsLoading(false);
                if (err.code === 'RequestAbortedError') {
                    console.log("upload aborted");
                } else {
                    console.log("upload failed");
                }
                return err;                
            }
            setIsLoading(false);
            const temp = data?.Key ? `${DIGITALOCEAN_PUBLIC_URL}/${data.Key}` : null;
            setLink(link => [...link, temp]);
        },
        onProgress: (percentage) => {
            const tempProgress = [...progressInfos];
            tempProgress[i].percentage = percentage;
            setProgressBar(tempProgress);
        },
        });

    }

    function listFile(){
        setIsLoading(true);
        listDigitalOceanSpacesObjects({ prefix: `${viewAs.value}/`, delimiter: "/" })
			.then((data) => {
				setIsLoading(false);
				setVideoList(data?.Contents || []);
			})
			.catch((err) => {
				setIsLoading(false);
				console.log(err);
			});
	}


    return <Container id="video_upload">
        {isLoading ? <Row><ProgressBar /></Row> : ""}
        <PageHeader title="Upload Video" />
        <div className="upload-main">
            <div className="select-customer-profile">
                <Row>
                    <Col s={12} m={3}>
                        <Select className="z-depth-1 select-view-as"
                            value={viewAs}
                            onChange={setViewAs}
                            options={
                                    (props.users?.customers || [])
                                .map(user => ({value: user.client_id, label: `${user.fullname} (${user.client_type})`}))
                            }
                            placeholder="Selet Customer Profile"/>
                    </Col>
                </Row>
             </div>
            {
                progressBar && progressBar?.map((item, i) => {
                    return <div className="row"><Col s={12} className="label-column11" >
                            <label><strong className="blue-text">{`File Upload Progress for ${item.fileName}: `}</strong>{item.percentage}%</label>
                            </Col></div>
                })
            }
            <div className="select-video">
               <TextInput type = "file" multiple onChange = {handleFileInput} disabled ={!viewAs} label = "Select Video "/> 
            </div>
            <div className="upload-warning-message">
				<div className="upload-warning-icon-wrapper">
					<span className="upload-warning-icon">!</span>
				</div>
				<span className="upload-warning-text">
					Filenames should not include special characters (e.g., #, $, %, &). Please follow our file naming convention YYYY.MM.DD_ClientName_ProjectName.
				</span>
			</div>
            <div className="upload-video-btns">
               <Button className="uploadbtn submit_btn" onClick={() => handleClick(selectedFile)} disabled = {(!viewAs) || !selectedFile} style ={{ margin : "5px" }} > Upload Video</Button>
                <Button className="uploadbtn submit_btn" onClick={listFile} disabled = {!viewAs} style ={{ margin : "5px" }} > List of videos</Button>
            </div>
        </div>
        <Row>
            {
                link && link?.map((item, i) => {
                return <Col s={12} style={{width:"91%"}} className="label-column11 after_upload" >
                    <label> <strong className="blue-text uploaded-video-link">{`Uploaded Video Link ${i+1} : `}</strong> {item}</label>
                    <Button icon = {<Icon>content_copy</Icon>} className = "text-copy-btn" tooltip ={toolTipText}  onClick={() => { navigator.clipboard.writeText(item); setToolTipText("Copied") }}/>
                </Col>
                })
            }
        </Row>
        {
            videoList && videoList.length > 0 &&
            <Table className = "highlight">
                <thead>
                    <tr>
                        <th>Sr.No</th>
                        <th>Video</th>
                        <th>Last Modified</th>
                        <th>Link</th>
                        <th>Copy</th>
                    </tr>
                </thead>
                <tbody>
                    {
                       videoList.sort((a, b) => new Date(b.LastModified) - new Date(a.LastModified))
                       .map((videos, i) => {
                            let p = videos.Key.search("/");
                            return (
                                <tr key = {"table-key-"+i}>
                                    <td>{i+1}</td>
                                    <td>{videos.Key.slice(p+1)}</td>
                                    <td>{videos.LastModified.toString()}</td>
                                    <td>{`${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`}</td>
                                    <td>
                                        {<Button icon = {<Icon>content_copy</Icon>} className = "text-copy-btn"
                                            onClick={() => {navigator.clipboard.writeText(
                                                `${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`
                                                )}}/>}
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table>
        }
        {
            videoList && videoList.length === 0 &&
            <Col s={12} className="label-column11 no-uploaded-videos-found" >
                <label>No Uploaded Videos Found </label>
            </Col>
        }
    </Container>
});

function mapStateToProps({cards, auth, users, settings}) {
    return {cards, auth, users, settings};
};

